export default __webpack_public_path__ + "static/attribution@2x-d66dd0ec49c03f6ba401354859bfca13.png";